import classNames from 'classnames'
import AcceptIcon from 'assets/images/loans/accepted.svg'
interface IUser extends IWithDrawUser {
    isSelected: boolean
}
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
interface IItemProps {
    item: IUser
    index: number
    handleSelect: (id: number) => void
    setSelectedUser: React.Dispatch<
        React.SetStateAction<ISelectUser | undefined>
    >
    setMemberId: React.Dispatch<React.SetStateAction<number | undefined>>
}
export default function Item({
    item,
    index,
    handleSelect,
    setSelectedUser,
    setMemberId,
}: IItemProps) {
    return (
        <div
            className={classNames(
                ' my-3 flex justify-between items-center px-2 cursor-pointer py-1',
                item.isSelected && ' rounded-full border-1 border-green-1'
            )}
            onClick={() => {
                handleSelect(item.id)
                setSelectedUser({
                    name: item.member.first_name + ' ' + item.member.last_name,
                    id: item.id,
                    memberId: item.member.id,
                })
            }}
        >
            <p
                className={classNames(
                    ' text-sm',
                    item.isSelected && 'text-green-1'
                )}
            >
                {item.member.first_name} {item.member.last_name}
            </p>
            {item.isSelected ? (
                <img src={AcceptIcon} alt="accept" />
            ) : (
                <div className="h-2 w-2 rounded-full p-1.5 border-1 border-gray-4"></div>
            )}
        </div>
    )
}
